export default __webpack_public_path__ + "static/media/payment.845537d1.png";